
<style type="text/css" media="screen">
.step-div{
	min-height: 280px
}
</style>
<template>
	<div class="text-center">
		<v-dialog persistent v-model="dialog.flag" width="500" >
			<v-card class="pa-5 pt-2  text-left" v-if="plan">
				<p class="text-right pr-3">
					<v-icon color="#8F8F8F" small
					@click="dialog.flag=false">
					mdi-window-close
				</v-icon>
			</p>
			<v-stepper v-model="step" class="elevation-0">
				<v-stepper-items>
					<!--  step 1 -->
					<v-stepper-content step="1" class="py-0">
						<v-row class="mt-2 ">
							<v-col md="12" class="text-left pl-5">
								<p class="sub-title-text">{{plan.name}}</p>
								<p class="subscription-description mt-2">
									{{plan.description}}
								</p>
							</v-col>
							<v-col md="8" class="text-left pl-5 py-1">
								<div class="page-title text-left">
									<p class="fs-13 fw-500">
										{{$lang.PRICE}}:
									</p>
									<span class="fw-normal">
										<v-icon class="inr-icon"  color="#303030" small >mdi-currency-inr</v-icon>
										{{plan.price}}
									</span>
									<span class="fs-10 sub-text-light"> +{{plan.gst_percent}}%GST</span>
								</div>
							</v-col>
							<v-col md="4" class="text-right pa-0">
								<div class="page-title text-left">
									<p class="fs-13 fw-500">
										{{$lang.VALIDITY}}:
									</p>
									<span class="fw-normal">
										{{plan.validity}} {{$lang.DAYS}}
									</span>
								</div>
							</v-col>

							<v-col md="8" class="text-left pl-5 py-0">
								<div class="page-title text-left">
									<p class="fs-13 fw-500">
										{{$lang.NO_OF_SHIPMENT_ALLOWED}}:
									</p>
									<span class="fw-normal">
										{{plan.shipment_count}}
									</span>
								</div>
							</v-col>

							<v-col md="4" class="text-right pa-0 py-0">
								<div class="page-title text-left">
									<p class="fs-13 fw-500">
										{{$lang.TYPE}}:
									</p>
									<span class="fw-normal">
										{{plan.type}}
									</span>
								</div>
							</v-col>

						</v-row>
						<!-- Payment methods  block -->
						<div>
							<div class="text-right pl-2 pt-1">
								<p class="page-title text-left fs-13 fw-500">
									{{$lang.PAYMENT_METHODS}}
								</p>
								<v-radio-group v-model="payment_method" :mandatory="false" class="mt-0">
									<v-radio :label="option" :value="option" v-for="(option,i) in payment_methods_option" :key="i" class="radio-btn"></v-radio>
								</v-radio-group>
							</div>
							<form method="post" :action="paytm_url+'?mid='+paytm_mid+'&orderId='+order_id" name="paytm">
								<table border="0" class="d-none">
									<tbody>
										<input type="text" name="mid" :value="$keys.PAYTM_MID">
										<input type="text" name="orderId" :value="order_id">
										<input type="text" name="txnToken" :value="transaction_token">
									</tbody>
								</table>
								<div class="text-center">
									<v-btn  type="submit" color="primary" :loading="btn_loading" id="submitBtn"  ref="submitBtn" style="display:none">{{$lang.CONTINUE}}</v-btn>
								</div>
							</form>
							<div class="text-center">
								<v-btn color="primary" :disabled="!payment_method?true:false" :loading="btn_loading" @click="continueHandler" >{{$lang.CONTINUE}}</v-btn>
							</div>
						</div>

					</v-stepper-content>

					<!--  step 2 -->
					<v-stepper-content step="2">
						<div class="mt-4 ml-5 ">
							<v-row class="w-100">
								<v-col md="8" class="text-left pl-5 py-0">
									<div class="sub-text-light fs-600 text-left">
										{{$lang.PRICE}}:
									</div>
								</v-col>
								<v-col md="2" class="text-right py-0">
									<div class="sub-text-light fs-12 fw-600 text-right">
										{{plan.price}}
									</div>
								</v-col>
								<v-col md="8" class="text-left pl-5 py-0">
									<div class="sub-text-light fs-600 text-left">
										{{$lang.GST_TEXT}}({{plan.gst_percent}}%):
									</div>
								</v-col>
								<v-col md="2" class="text-right py-0">
									<div class="sub-text-light fs-12 fw-600 text-right">
										+{{plan.payable_amount-plan.price}}.00
									</div>
								</v-col>
								<v-col md="10" class="py-0">
									<hr style="height:1px;">
								</v-col>
								<v-col md="8" class="text-left pl-5 py-0">
									<div class="sub-text-light fs-600 text-left">
										{{$lang.TOTAL_AMOUNT}}:
									</div>
								</v-col>
								<v-col md="2" class="text-right py-0">
									<div class="page-title fs-12 fw-600 text-right">
										{{plan.payable_amount}}
									</div>
								</v-col>
							</v-row>
						</div>

						<div  v-if="payment_method=='NEFT/IMPS'" class="custome-form step-div pt-5" >
							<span  class="pre-formatted"> {{neft_imps_payment_instructions}}</span>
							<div class="text-center mt-8">
								<v-btn color="primary" :loading="btn_loading" @click="buyNow">{{$lang.CONTINUE}}</v-btn>
							</div>
						</div>
						<div  v-if="payment_method=='Cheque'"  class="custome-form step-div  pt-5">
							<span  class="subscription-description fs-16 pre-formatted" >{{cheque_payment_instructions}}</span>
							
							<div class="text-center mt-8">
								<v-btn color="primary" :loading="btn_loading" @click="buyNow" >{{$lang.CONTINUE}}</v-btn>
							</div>
						</div>

					</v-stepper-content>
					<!-- step 3(success msg) -->
					<v-stepper-content step="3" class="py-0">
						<v-card class="elevation-0">
							<v-card-title
							class="headline flex-column lighten-2"
							primary-title
							>
							<img src="@/assets/check.svg" alt="" width="150px">
							<p class="success-text fw-bold  fs-18 mt-2">
								{{$lang.SUCCESS.toUpperCase()}}
							</p>
						</v-card-title >
						<v-card-text >
							<p class="subscription-description text-center">
								{{thank_you_message}}
							</p>
						</v-card-text>
					</v-card>

					<div class="text-center">
						<v-btn color="primary" @click="dialog.flag=false" > <b>{{$lang.CONTINUE}} </b></v-btn>
					</div>
				</v-stepper-content>

			</v-stepper-items>
		</v-stepper>
	</v-card> 
</v-dialog>
</div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex';
export default{
	props:["dialog","plan","cheque_payment_instructions",'neft_imps_payment_instructions'],
	data(){
		return{
			btn_loading:false,
			step:1,
			payment_method:"",
			payment_methods_option:[
			"Cheque",
			"NEFT/IMPS",
			"Paytm"],
			order_id:"",
			transaction_token:"",
			cheque_no:"",
			neft_ref_no:"",
			today:new Date().toISOString().substr(0, 10),
			transaction_date:new Date().toISOString().substr(0, 10),
			thank_you_message:""
		}
	},
	computed: mapGetters({
		paytm_mid: 'getPaytmMid',
		paytm_url: 'getPaytmUrl',
	}),
	methods:{
		/* initiate  purches sudbscription */ 
		buyNow(){
			console.log(this.plan)
			this.$store.dispatch('setPageLoader', true)
			const self=this
			self.btn_loading=true
			let params={
				id:this.plan.id,
				is_website:"True",
				payment_mode:self.payment_method
			};
			

			const successHandler = (response) => {
				if(response.data.success){
					/* if payment methods  is paytm*/ 
					if (self.payment_method=="Paytm"){
						self.transaction_token=response.data.transaction_token;
						self.order_id=response.data.paytm_order_id;
						setTimeout(()=>{
							document.getElementById("submitBtn").click()
						},500);
					}else{
						/* if payment method  is check of neft */ 
						this.thank_you_message=response.data.thank_you_message
						this. step=3
					}

				}
			};
			const finallyHandler = () => {
				self.btn_loading=false
				this.$store.dispatch('setPageLoader', false)
			};
			self.request_GET( self,self.$urls.INITIATE_PAYMENT,params,successHandler,null,null,finallyHandler)

		},
		continueHandler(){
			if (this.payment_method=="Paytm"){
				this.buyNow()
			}
			else
				this.step=2
		}
	}

}

</script>